import GlobalCallbackStatusBadge from "views/components/Badges/GlobalCallbackStatusBadges";

export function GlobalCallbackLogModal ({ log }) {
  return (
    <div className="card mb-3">
      <div className="card-header border-bottom">
        <h5 className="card-title mb-0">
          <i className="fa-solid fa-circle-info me-1" /> Summary
        </h5>
      </div>
      <div className="card-body mt-3">
        <div className="row g-3">
          <div className="col-6 col-md-3">
            <div className="text-muted small">Date / Time</div>
            <div className="fw-semibold">{new Date(log.creation).toLocaleString('id-ID')}</div>
          </div>
          <div className="col-6 col-md-3">
            <div className="text-muted small">Type</div>
            <div className="fw-semibold">
              <span className="status-secondary">{log.type || 'N/A'}</span>
            </div>
          </div>
          <div className="col-6 col-md-3">
            <div className="text-muted small">Prefix</div>
            <div className="fw-semibold text-primary">{log.prefix || '-'}</div>
          </div>
          <div className="col-6 col-md-3">
            <div className="text-muted small">Status Code</div>
            <div>
              <GlobalCallbackStatusBadge statusCode={log.status_code} />
            </div>
          </div>
          <div className="col-12 col-md-6 mt-3">
            <div className="text-muted small">Callback URL</div>
            <div className="fw-semibold text-break">
              <code style={{ fontSize: '1.1em' }}>{log.callback_url}</code>
            </div>
          </div>
          <div className="col-6 col-md-3 mt-3">
            <div className="text-muted small">Created By</div>
            <div className="fw-semibold">{log.created_by || 'system'}</div>
          </div>
          <div className="col-6 col-md-3 mt-3">
            <div className="text-muted small">Last Modified</div>
            <div className="fw-semibold">{new Date(log.modified).toLocaleString('id-ID')}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
